<a class="cursor-pointer" (click)="addParticipant()">
    <div class="circle">+</div>
    <span class="participant-register-text" translate> GroupClassDetails.AddParticipantButton</span>
</a>
